export default __webpack_public_path__ + "static/media/Snd_TryC.ad1a5b22.mp3";